import React, { useEffect, useState } from "react";
import { Button, Row, Col, Spinner } from "react-bootstrap";
import { useGetImagePathByIdQuery } from "features/onboarding/users/farmer/farmerApiSlice";
import { DataGrid } from "@mui/x-data-grid";
import StateDistrict from "features/onboarding/users/farmer/StateDistrict";
import CustomSearchBar from "components/CustomSearchBar";
import Pagination from "@mui/material/Pagination";
import { toast } from "react-toastify";
import { API_URL } from "app/config";
import { store } from "app/store";
import { Table } from "reactstrap";
import {
  useGetCrmInsuranceLeadsQuery,
  useUploadInsuranceFarmerDocsMutation,
} from "features/Insurance/InsuranceApiSlice";
import {
  CheckCircleOutlined,
  FileTextOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";

export const InsuranceClaimsDownloadTask = ({ orgId }) => {
  const [selectedFarmerIds, setSelectedFarmerIds] = useState([]);
  const [state_id, setStateId] = useState("");
  const [district_id, setDistrictId] = useState("");
  const [block_id, setBlockId] = useState("");
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [blockName, setBlockName] = useState("");
  const [blockList, setBlockList] = useState([]);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [farmerRows, setfarmerRows] = useState([]);
  const [downloadsLoading, setDownloadsLoading] = useState(false);
  const [selectedEntityIds, setSelectedEntityIds] = useState([]);

  const [multipleDownloadFarmers] = useUploadInsuranceFarmerDocsMutation();
  const [sendImagePath, setImagePath] = useState("");
  const { data: pathImage, refetch: pathRefetch } = useGetImagePathByIdQuery(
    sendImagePath
  );
  const [statusName, setStatusName] = useState("");
  const [pagination, setPagination] = useState({
    page: 1,
    pageCount: 0,
    perPage: 100,
  });

  const queryParameters = React.useMemo(
    () => ({
      page: pagination.page,
      perPage: pagination.perPage,
      searchKey: debouncedSearch || "",
      selectedProduct: "Cattle_Claims",
      stateCode: state_id,
      districtCode: district_id,
      blockCode: block_id,
      statusName: statusName,
      statusIncludes: "",
    }),
    [
      pagination.page,
      pagination.perPage,
      debouncedSearch,
      state_id,
      district_id,
      block_id,
      statusName,
    ]
  );
  const { data, isLoading: farmerLoading } = useGetCrmInsuranceLeadsQuery(
    queryParameters,
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const [showDownloads, setShowDownloads] = useState(false);
  const [reportingData, setReportingData] = useState([]);

  useEffect(() => {
    const dataFromApi = data?.data ? data?.data?.results : [];
    const currentPage = data?.data?.current_page || pagination.page;
    const totalPages = data?.data?.pages || pagination.pageCount;
    const perPageFromApi = data?.data?.per_page || pagination.perPage;
    setfarmerRows(dataFromApi);
    setPagination((prev) => {
      if (
        prev.page !== currentPage ||
        prev.pageCount !== totalPages ||
        prev.perPage !== perPageFromApi
      ) {
        return {
          page: currentPage,
          pageCount: totalPages,
          perPage: perPageFromApi,
        };
      }
      return prev;
    });
  }, [data]);
  const fetchDashboard = async () => {
    setDownloadsLoading(true);

    try {
      const state = store.getState();
      const url = `${API_URL}/api/v1/onboarding/services/tasks`;
      const response = await fetch(url, {
        headers: { authorization: `Bearer ${state.auth.accessToken}` },
      });

      if (!response.ok) throw new Error("Network response was not ok");

      const data = await response.json();

      const filteredData =
        data?.data?.filter(
          (item) => item.results?.task_type === "claims_documents"
        ) || [];

      setReportingData(filteredData);
      setDownloadsLoading(false);
    } catch (error) {
      console.error("Fetch error:", error);
      setDownloadsLoading(false);
    }
  };
  useEffect(() => {
    if (showDownloads) {
      fetchDashboard();
    }
  }, [showDownloads]);
  useEffect(() => {
    if (!pathImage?.data?.url) return;
    const link = document.createElement("a");
    link.href = pathImage.data.url;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, [pathImage]);

  const formatDateTime = (dateString) => {
    if (!dateString) return "";

    let date;

    if (dateString.includes("T")) {
      date = new Date(dateString);
    } else {
      const [datePart, timePart] = dateString.split(" ");
      const parts = datePart?.split("/");

      if (parts?.length === 3) {
        const [day, month, year] = parts;

        const time = timePart ? `${timePart}:00` : "00:00:00";

        date = new Date(`${year}-${month}-${day}T${time}`);
      }
    }

    if (!date || isNaN(date.getTime())) return "";

    const day = date.getDate();
    const month = date.toLocaleString("en-IN", { month: "long" });
    const year = date.getFullYear();

    const time = date
      .toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(" ", "")
      .toUpperCase();

    return `${day} ${month} ${year} , ${time}`;
  };
  const customStyles = {
    control: (base) => ({
      ...base,
      height: 40,
      minHeight: 40,
    }),
  };
  const columns = [
    {
      field: "application_number",
      headerName: "Reference No.",
      width: 200,
      renderCell: ({ row }) => {
        const tag = row?.lead_details?.[0]?.application_id;

        return <div>{tag}</div>;
      },
    },

    {
      field: "tag_number",
      headerName: "Cattle Tag No",
      width: 150,
      renderCell: ({ row }) => {
        const tag =
          row?.lead_details?.[0]?.service_details?.incident_details
            ?.cattle_tag_number;

        return (
          <div
            style={{
              textAlign: "center",
              fontSize: "14px",
              color: "steelblue",
              fontWeight: 500,
            }}
          >
            {tag}
          </div>
        );
      },
    },

    {
      field: "incident_date_time",
      headerName: "Occurrence DateTime",
      width: 210,
      renderCell: ({ row }) =>
        formatDateTime(
          row?.lead_details?.[0]?.service_details?.incident_details
            ?.incident_date_time
        ),
    },

    {
      field: "created_at",
      headerName: "Reported DateTime",
      width: 210,
      renderCell: ({ row }) => formatDateTime(row?.created_at),
    },
    {
      field: "cattle_type",
      headerName: "Cattle Type",
      width: 150,
      renderCell: ({ row }) => {
        const tag =
          row?.lead_details?.[0]?.service_details?.incident_details
            ?.cattle_type;

        return <div>{tag}</div>;
      },
    },
    {
      field: "cause_loss",
      headerName: "Cause Of Loss",
      width: 150,
      renderCell: ({ row }) => {
        const tag =
          row?.lead_details?.[0]?.service_details?.incident_details
            ?.cause_of_loss;

        return (
          <div
            style={{
              textAlign: "center",
              fontSize: "14px",
              color: "steelblue",
              fontWeight: 500,
            }}
          >
            {tag}
          </div>
        );
      },
    },

    {
      field: "current_status",
      headerName: "Current Status",
      width: 240,
      renderCell: ({ row }) => {
        const statusConfig = {
          "Claim Approved": {
            color: "green",
            icon: <FileTextOutlined />,
          },
          "Claim Settled": { color: "gold", icon: <CheckCircleOutlined /> },
          "Claim Declined": { color: "error", icon: <WarningOutlined /> },
          "Claim Rejected": { color: "error", icon: <WarningOutlined /> },
          "Claim Accepted": { color: "volcano", icon: <FileTextOutlined /> },
        };

        const { color, icon } = statusConfig[row.current_status] || {
          color: "geekblue",
          icon: <FileTextOutlined />,
        };

        return (
          <Tag
            bordered={false}
            color={color}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "3px 9px",
              fontSize: "13px",
              fontWeight: "500",
              borderRadius: "6px",
            }}
          >
            {icon}
            <span>
              {row.current_status
                ?.toLowerCase()
                .replace(/_/g, " ")
                .replace(/\b\w/g, (char) => char.toUpperCase())}
            </span>
          </Tag>
        );
      },
    },

    {
      field: "full_name",
      headerName: "Farmer Name",
      width: 180,
    },

    {
      field: "phone_number",
      headerName: "Phone No.",
      width: 150,
      renderCell: ({ row }) => (
        <div style={{ fontSize: "14px", color: "#555", fontWeight: 500 }}>
          {row.phone_number}
        </div>
      ),
    },

    {
      field: "lead_source",
      headerName: "Lead Source",
      width: 150,
    },
  ];

  const onLocationChange = (event) => {
    if (event.ConditionName === "state") {
      setBlockId("");
      setDistrictName("");
      setDistrictId("");
      setBlockName("");
      setBlockList([]);
      setStateId(event.value);
      setStateName(event.label);
    }
    if (event.ConditionName === "district") {
      setDistrictId(event.value);
      setDistrictName(event.label);
      setBlockId("");
      setBlockName("");
    }
    if (event.ConditionName === "block") {
      setBlockId(event.value);
      setBlockName(event.label);
    }
    setPagination({ page: 1, pageCount: 0, perPage: 50 });
  };

  const reportBulkData = async () => {
    // if(selectedFarmerIds?.length===0){
    //    Swal.fire({
    //            title: "Select Cattle",
    //            text: "Please select Cattle to continue.",
    //            icon: "warning",
    //            showCancelButton: true,
    //            confirmButtonText: "Continue",
    //            cancelButtonText: "Cancel",
    //            confirmButtonIcon: "fas fa-arrow-right",
    //          });
    //          return;
    // }
    const responseData = {
      farmer_id_list: selectedFarmerIds,
      zip_file_name: "Leads",
      background: true,
      task_type: "claims_documents",
      categories: ["cattle claim documents", "kyc documents", "bank documents"],
      entity_is: selectedEntityIds,
    };
    multipleDownloadFarmers(responseData)
      .unwrap()
      .then((data) => {
        toast.success("Task Created Successfully !!");
      })
      .catch((error) => {
        toast.error("Error while Creating Task");
        return;
      });
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchKey.trim() ? searchKey : "");
    }, 500);
    return () => clearTimeout(handler);
  }, [searchKey]);

  const handleChangeSearch = (value) => {
    setSearchKey(value);
    setPagination({ page: 1, pageCount: 0, perPage: 50 });
  };

  const CustomPagination = () => {
    return (
      <Pagination
        color="primary"
        count={pagination?.pageCount}
        page={pagination?.page}
        onChange={(event, value) => {
          setPagination({
            page: value,
            pageCount: pagination?.pageCount,
            perPage: pagination.perPage,
          });
        }}
        variant="outlined"
        shape="rounded"
      />
    );
  };

  const handleStatusChange = (selectedOption) => {
    if (selectedOption) {
      setStatusName(selectedOption.value);
    } else {
      setStatusName("");
    }
  };
  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-center gap-2 mb-3">
        <Button
          size="sm"
          variant={showDownloads ? "outline-warning" : "warning"}
          onClick={() => setShowDownloads(false)}
        >
          Create New Task
        </Button>

        <Button
          size="sm"
          variant={showDownloads ? "warning" : "outline-warning"}
          onClick={() => setShowDownloads(true)}
        >
          Previous Downloads
        </Button>
      </div>

      {!showDownloads ? (
        <>
          <Row style={{ backgroundColor: "#f8f8f8" }}>
            <Col md={2} className="mt-3">
              <CustomSearchBar sendSearchFunction={handleChangeSearch} />
            </Col>
            <Col md={6}>
              <StateDistrict
                onLocationChange={onLocationChange}
                state_id={state_id}
                district_id={district_id}
                block_id={block_id}
                stateName={stateName}
                districtName={districtName}
                blockName={blockName}
                setBlockList={setBlockList}
                blockList={blockList}
                noBlock={true}
                setStateName={setStateName}
                setDistrictName={setDistrictName}
                setStateId={setStateId}
                setDistrictId={setDistrictId}
                dynamicCol='6'
              />
            </Col>
            <Col sm="3" className="mb-2 position-relative mt-3">
                                  <Select
                                    menuPlacement="auto"
                                    options={[
                                      {
                                        value: "Lead Generated",
                                        label: "Lead Generated",
                                      },
            
                                      {
                                        value: "Claim Accepted",
                                        label: "Claim Accepted",
                                      },
                                      {
                                        value: "Claim Declined",
                                        label: "Claim Declined",
                                      },
                                      {
                                        value: "Claim Approved",
                                        label: "Claim Approved",
                                      },
            
                                      {
                                        value: "Claim Rejected",
                                        label: "Claim Rejected",
                                      },
                                      {
                                        value: "Claim Settled",
                                        label: "Claim Settled",
                                      },
                                    ]}
                                    placeholder="Status"
                                    value={
                                      statusName
                                        ? { value: statusName, label: statusName }
                                        : null
                                    }
                                    onChange={handleStatusChange}
                                    styles={customStyles}
                                  />
                                  {statusName && (
                                    <span
                                      className="clear-icon"
                                      onClick={() => {
                                        setStatusName("");
                                      }}
                                      style={{
                                        position: "absolute",
                                        top: "50%",
                                        right: "40px",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "gray",
                                        fontSize: "12px", 
                                        zIndex: 1000, 
                                      }}
                                    >
                                      ✕
                                    </span>
                                  )}
                                </Col> 
          </Row>

          <div className="d-flex justify-content-between align-items-center my-3">
            <h5 className="mb-0">Select Leads</h5>
            <div className="d-flex gap-2">
              <Button variant="success" size="sm" onClick={reportBulkData}>
                Submit
              </Button>
            </div>
          </div>

          {farmerLoading ? (
            <div className="d-flex flex-column justify-content-center align-items-center py-5">
              <Spinner
                animation="border"
                variant="primary"
                role="status"
                style={{ width: "2rem", height: "2rem" }}
              >
                <span className="visually-hidden">Loading...</span>
              </Spinner>
              <div className="mt-3">
                <strong>Loading farmer data...</strong>
              </div>
            </div>
          ) : (
            // <DataGrid
            //   rows={farmerRows}
            //   columns={columns}
            //   rowsPerPageOptions={[3]}
            //   checkboxSelection
            //   keepNonExistentRowsSelected
            //   onRowSelectionModelChange={(selectedIds) => {
            //     const selectedUserIds = selectedIds
            //       .map((id) => farmerRows.find((row) => row.id === id)?.user_id)
            //       .filter((userId) => userId);
            //     setSelectedFarmerIds(selectedUserIds);
            //   }}
            //   components={{
            //     Pagination: CustomPagination,
            //   }}
            // />
            <DataGrid
              rows={farmerRows}
              columns={columns}
              checkboxSelection
              keepNonExistentRowsSelected
              onRowSelectionModelChange={(selectedIds) => {
                const selectedIdSet = new Set(selectedIds);

                const farmerIds = [];
                const entityIds = [];

                farmerRows.forEach((row) => {
                  if (!selectedIdSet.has(row.id)) return;
                  if (row.user_id) {
                    farmerIds.push(row.user_id);
                  }
                  const cattle =
                    row?.lead_details?.[0]?.service_details?.incident_details;

                  if (cattle?.cattle_tag_number && cattle?.cattle_id) {
                    entityIds.push(
                      `${cattle.cattle_tag_number}_${cattle.cattle_id}`
                    );
                  }
                });

                setSelectedFarmerIds(farmerIds);
                setSelectedEntityIds(entityIds);
              }}
              components={{
                Pagination: CustomPagination,
              }}
            />
          )}
        </>
      ) : (
        <div>
          <Button
            className="bg-transparent text-black float-end"
            style={{
              border: "1px solid #829999",
              color: "#343737",
              marginTop: "0",
            }}
            size="sm"
            onClick={() => fetchDashboard()}
          >
            <FontAwesomeIcon icon={faRotateLeft} />
          </Button>
          {downloadsLoading ? (
            <div className="d-flex justify-content-center align-items-center py-4">
              <Spinner animation="border" size="sm" />
            </div>
          ) : (
            <Table striped hover>
              <thead>
                <tr>
                  <th className="th-sm">Status</th>
                  <th className="th-sm">Created At</th>
                  <th className="th-sm">File</th>
                </tr>
              </thead>
              <tbody>
                {reportingData && reportingData.length > 0 ? (
                  reportingData.map((field, index) => (
                    <tr key={index}>
                      <td>{field.status}</td>

                      <td>
                        {(() => {
                          if (!field.created_at) return "N/A";

                          const date = new Date(field.created_at);

                          const formattedDate = date.toLocaleDateString(
                            "en-GB",
                            {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                            }
                          );

                          const formattedTime = date.toLocaleTimeString(
                            "en-GB",
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            }
                          );

                          return (
                            <>
                              {formattedDate}{" "}
                              <span className="text-muted mx-2">
                                ({formattedTime})
                              </span>
                            </>
                          );
                        })()}
                      </td>

                      <td>
                        {field?.results?.zip_file_path ? (
                          <Button
                            size="sm"
                            className="text-warning"
                            onClick={() => {
                              setImagePath(field?.results?.zip_file_path);
                              pathRefetch();
                            }}
                          >
                            <i
                              className="mdi mdi-download"
                              style={{ color: "white" }}
                            ></i>
                          </Button>
                        ) : (
                          <span className="mx-3"> - </span>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center text-muted py-3">
                      No Data Available
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>
      )}
    </div>
  );
};
